import http from '@utils/http';

/**
 * Sales module – aligned with backend /api/v1/sales and RBAC_Roles_And_Permissions.md
 * Permissions: sales.leads.view, sales.leads.create, sales.leads.update, sales.leads.delete, etc.
 */

/**
 * GET /api/v1/sales/leads
 * Response shape: { data: [...], total, page, limit, totalPages } (array at payload.data or payload).
 * @param {{ page?: number, limit?: number, sortBy?: string, sortOrder?: string }} params
 */
export const getSalesLeads = (params = {}) =>
    http.get('/sales/leads', { params }).then((res) => {
        const payload = res.data ?? {};
        let list = payload.data ?? payload;
        if (list && typeof list === 'object' && !Array.isArray(list) && Array.isArray(list.data)) {
            list = list.data;
        }
        const data = Array.isArray(list) ? list : [];
        return {
            data,
            total: payload.total ?? data.length,
            page: payload.page ?? 1,
            limit: payload.limit ?? 10,
            totalPages: payload.totalPages ?? 1,
        };
    });

/**
 * GET /api/v1/sales/leads/:id
 */
export const getSalesLeadById = (id) => http.get(`/sales/leads/${id}`).then((res) => res.data?.data ?? res.data);

/**
 * POST /api/v1/sales/leads
 * @param {{ name?: string, email?: string, phone?: string, company?: string, source?: string, notes?: string }} body
 */
export const createSalesLead = (body) => http.post('/sales/leads', body).then((res) => res.data?.data ?? res.data);

/**
 * PATCH /api/v1/sales/leads/:id
 * @param {string} id
 * @param {{ name?: string, email?: string, phone?: string, company?: string, source?: string, notes?: string, stage?: string, status?: string, assignedToUserId?: string }} body
 */
export const updateSalesLead = (id, body) =>
    http.patch(`/sales/leads/${id}`, body).then((res) => res.data?.data ?? res.data);

/**
 * DELETE /api/v1/sales/leads/:id (soft-delete)
 */
export const deleteSalesLead = (id) => http.delete(`/sales/leads/${id}`).then((res) => res.data?.data ?? res.data);

/**
 * PATCH /api/v1/sales/leads/:id/stage
 * @param {string} leadId
 * @param {string} stage - e.g. contacted, proposal_sent, negotiation
 */
export const patchLeadStage = (leadId, stage) =>
    http.patch(`/sales/leads/${leadId}/stage`, { stage }).then((res) => res.data?.data ?? res.data);

/**
 * PATCH /api/v1/sales/leads/:id/status
 * @param {string} leadId
 * @param {string} status - active, qualified, disqualified, converted, lost
 */
export const patchLeadStatus = (leadId, status) =>
    http.patch(`/sales/leads/${leadId}/status`, { status }).then((res) => res.data?.data ?? res.data);

/**
 * POST /api/v1/sales/leads/:id/invite-client
 * @param {string} leadId
 */
export const inviteClient = (leadId) =>
    http.post(`/sales/leads/${leadId}/invite-client`).then((res) => res.data?.data ?? res.data);
